import React from 'react';
import './TeacherStatsComponent.css'

function TeacherStatsComponent() {
  return (
    <div className='teacher-stats-component'>
        <span className='teacher-stats-title'>Subscribe</span>
        <div className='teacher-stats-line' />
        <span className='teacher-stats-number'>3203</span>
        <span className='teacher-stats-update'>Last update Yesterday</span>
    </div>
  )
}

export default TeacherStatsComponent